import { clsxMerge } from "shared/lib/helpers";
import { handleCalendlyPopup } from "@/helpers/calendly";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

export const CustomerSuccessRequestDemo = ({
  className,
}: PropsWithClassNameI) => (
  <div
    className={clsxMerge(
      "flex w-full flex-col rounded-xl",
      "bg-[rgba(255,255,255,0.6)] shadow-landing-card",
      "mt-5 items-center gap-7 py-[30px] text-center backdrop-blur-[10px] lg:w-[370px]",
      className
    )}
  >
    <h5 className="w-[180px] typography-header-6 sm:w-full lg:max-w-[196px]">
      Book a pipeline consultation
    </h5>

    <p className="max-w-[173px] typography-body-3">
      Let us help you grow your pipeline.
    </p>

    <button
      className="btn-lg-highlighted w-[198px]"
      onClick={handleCalendlyPopup}
    >
      Request a demo
    </button>
  </div>
);
